import React, { useCallback } from 'react'
import { Container, Row, Col, Card, CardBody, } from 'reactstrap'
import DataTable from 'react-data-table-component';
import FilterComponent from '../../Components/Miscellaneous/SupportTicket/TicketTable/FilterComponent';

import CompanyOtherDetailsCard from '../../Components/settings/Company/RegisterCompany/components/CompanyOtherDetailsCard';
import CardHeaderCompany from '../../Components/settings/Company/RegisterCompany/components/CardHeaderCompany';
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import { backendbaseUrl } from './../../Utils/baseUrl';
import axiosInstance from '../../Utils/axiosInstance';
import { toast } from 'react-toastify';
import { CompanyListColumns } from '../../Components/settings/Company/RegisterCompany/CompanyListColumnsData';
import { confirmAlert } from "react-confirm-alert";
import "./CustomDialog.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import { LogDataColumns } from './LogData';


function AdminErrorPage() {

    const [filterText, setFilterText] = useState('');
    const [data, setData] = useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [planDelete, SetplanDelete] = useState(false);
    // const [sortField, setSortField] = useState("purchased_date_"); // Default sorting field
    const [sortOrder, setSortOrder] = useState("desc"); // Default order
    const [tableRefresh, setTableReferesh] = useState(false)
    // State for Editing
    const [editRow, setEditRow] = useState<number | null>(null);
    const [editedValues, setEditedValues] = useState<any>({});

    const navigate = useNavigate()

    useEffect(() => {
        console.log("hello")

        let url = `${backendbaseUrl}/company/error/logs/?page=${currentPage}`;
        if (filterText) url += `&search=${filterText}`;
        if (rowsPerPage) url += `&page_size=${rowsPerPage}`;
        // if (sortField && sortOrder) {
        //     url += `&sort_by=${sortField}&order=${sortOrder}`;
        // }

        axiosInstance.get(url)
            .then((response) => {
                setData(response.data.results);
                setTotalPages(Math.ceil(response.data.count / rowsPerPage));
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, [currentPage, filterText, rowsPerPage, planDelete, sortOrder, tableRefresh]);

    const handlePageChange = (page: number) => setCurrentPage(page);
    const handleRowsPerPageChange = (newPerPage: number) => {
        setRowsPerPage(newPerPage);
        setCurrentPage(1);
    };



    const [modal, setModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null); // Store the item ID to delete


    const toggleModal = () => setModal(!modal);

    // Open modal and set the item ID to be deleted
    const confirmDelete = (id: any) => {
        setItemToDelete(id);
        toggleModal();
    };
    // const companyDetailsView =(id:any)=>{
    //     navigate(`/settings/company/list-register-company/${id}`)

    //   }


    const companyDetailsView = useCallback((id: any) => {
        navigate(`/settings/company/list-register-company/${id}`);
    }, []);


    const companyEditView = (id: string) => {
        navigate(`/settings/company/edit-registered-company/${id}`);
    }


    const viewLogDetails = (obj: any) => {
        navigate(`/settings/log/details/${obj}`);
    }

    const handleDelete = async () => {



        try {
            const response = await axiosInstance.delete(
                `${backendbaseUrl}/plans/delete/${itemToDelete}`
            );
            if (response.status === 204) {
                toast.success("Deleted Successfully")
                toggleModal();
                SetplanDelete(!planDelete)
            }

        } catch (error: any) {
            if (error.response) {
                if (error.response.status === 400) {
                    toast.error("Please fill every field");
                } else {
                    toast.error(
                        error.response.data.message || "An unknown error occurred"
                    );
                }
            } else {
                toast.error("Network error or server is down");
            }
        }

    }


    const handleSort = (column: any, sortDirection: string) => {
        let sortField = "";

        if (typeof column.selector === "function") {
            // Extract the column name using the column's "name" field
            sortField = column.name.toLowerCase().replace(/\s+/g, "_");
        } else {
            sortField = column.selector;
        }

        // setSortField(sortField);
        setSortOrder(sortDirection);
    };



    // When double-clicking, enable editing for the entire row
    const handleDoubleClick = (row: any) => {
        setEditRow(row.id);
        setEditedValues({
            first_name: row.first_name,
            email: row.email,
            company_name: row.company_name
        });
    };

    // Handle input changes for edited fields
    const handleChange = (rowId: number, e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setEditedValues((prev: { [key: string]: string }) => ({ ...prev, [name]: value }));

    };

    // Handle submitting changes
    const handleSubmit = (rowId: number) => {
        // Find the row and update the data
        setData((prevData) =>
            prevData.map((row) =>
                row.id === rowId ? { ...row, ...editedValues } : row
            )
        );

        // Send updated data to backend
        axiosInstance.put(`${backendbaseUrl}/company/company-trail/${rowId}/`, editedValues)
            .then(() => {
                console.log("Updated successfully!");
            })
            .catch((error) => {
                console.error("Error updating:", error);
            });

        // Exit edit mode
        setEditRow(null);
    };



    function CreatePlanPage(): void {
        navigate('/settings/plans-and-pricing/create-plans')
    }
    const handleViewCompany = (id: number) => {
        navigate(`/settings/company/list-register-company/${id}`);
    };

    const approveCompany = (row: any) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-confirm-box">
                        <h3>New Purchase : {row?.organization?.name}</h3>

                        <div className="details">
                            <p><strong>📅 Purchased on:</strong>{row.purchase_date}</p>
                            <p><strong>📌 Plan:</strong>{row.plan.name}</p>
                            <p><strong>🕒 Plan Validity:</strong> {row.plan.days} days</p>
                            <p><strong>👥 Users Allowed:</strong> {row.plan.max_users}</p>
                            <p><strong>🧾 Users Under Plan:</strong> {row.users_under_plan}</p>
                            {/* <p><strong>💰 Amount:</strong> ₹row.amount || "N/A"</p> */}
                            <p><strong>🏦 Payment Mode:</strong>{row.is_online_purchase ? "Online Gateway" : "Manual/Offline"}</p>
                        </div>
                        <div className="btn-group">
                            <button className="approve-btn" onClick={() => {

                                const callApprovalApi = async () => {
                                    try {
                                        const response = await axiosInstance.get(`${backendbaseUrl}/company/company-plan/approval/${row.id}/approved`)
                                        if (response.status === 200) {
                                            toast.success("approved")
                                            setTableReferesh(!tableRefresh)
                                        }
                                    }

                                    catch {
                                        toast.error("unable to approve")

                                    }
                                }
                                callApprovalApi()
                                console.log(row);
                                onClose();
                            }}>✅ Approve</button>
                            <button className="reject-btn" onClick={() => {

                                const RecentProjectUpdateApprovalApi = async () => {
                                    try {
                                        const response = await axiosInstance.get(`${backendbaseUrl}/company/company-plan/approval/${row.id}/rejected`)
                                        if (response.status === 200) {
                                            toast.success("approved")
                                            setTableReferesh(!tableRefresh)
                                        }
                                    }

                                    catch {
                                        toast.error("unable to approve")

                                    }
                                }
                                RecentProjectUpdateApprovalApi()
                                onClose();
                            }}>❌ Reject</button>
                        </div>
                    </div>
                );
            }
        });
    };
    return (
        <div className="page-body">
            <div>

                <Container fluid>
                    <Row>
                        <Col sm={12}>

                        </Col>
                    </Row>
                </Container>

                <Container fluid>

                    <Row>
                        <Col sm={12}>
                            <Card>
                                <CardHeaderCompany
                                    headClass='pb-0 card-no-border'
                                    title="Log History"
                                    subTitle="You’ll see all your logs listed here"
                                />
                                <CardBody>
                                    <FilterComponent
                                        onFilter={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                        filterText={filterText}
                                    />
                                    <DataTable
                                        className="custom-scrollbar"
                                        data={data}
                                        columns={LogDataColumns(viewLogDetails, companyEditView)}
                                        // expandableRowsComponent={CustomExpandableComponent}

                                        pagination
                                        paginationServer
                                        paginationTotalRows={totalPages * rowsPerPage}
                                        paginationDefaultPage={currentPage}
                                        onChangePage={handlePageChange}
                                        onChangeRowsPerPage={handleRowsPerPageChange}
                                        // expandableRows={true}
                                        striped
                                        sortServer
                                        onSort={handleSort}
                                        highlightOnHover
                                        paginationRowsPerPageOptions={[10, 25, 50]}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div >
        </div>
    )
}

export default AdminErrorPage